import { useQuery } from '@tanstack/react-query';
import { sampleInfoResponse, SubscriptionStatusResponse, FeatureKeysResponse } from './MiscModel';
import { misc } from '../../api/Endpoints';
import { QUERY_KEYS } from '../../api/config';

export const useGetSampleDetailsQuery = () => {
  return useQuery<sampleInfoResponse, Error>({
    queryKey: [QUERY_KEYS.SAMPLE_DETAIL],
    queryFn: async () => {
      const response = await misc.getSampleDetails();
      return response.data;
    },
  });
};

export const useGetSubscriptionStatusQuery = () => {
  return useQuery<SubscriptionStatusResponse, Error>({
    queryKey: [QUERY_KEYS.SUBSCRIPTION_STATUS],
    queryFn: async () => {
      const response = await misc.getSubscriptionStatus();
      return response.data;
    },
  });
};

export const useGetFeatureKeys= () => {
  return useQuery<FeatureKeysResponse, Error>({
    queryKey: [QUERY_KEYS.FEATURE_KEYS],
    queryFn: async () => {
      const response = await misc.getFeatureKeys();
      return response.data;
    },
  });
}
